module.exports = __webpack_public_path__ + "202408221624/img/img_control_point@2x.79d423e5.png";